import { MutationTypes } from './mutation-types'
import BaseMutations from 'baseapp/store/mutations'
import {sysUtil} from "jscom/utils/sysutil"

export default {
  ...BaseMutations,
  /*
    @params [countInfos: object]: {CONTRACTID: {SKUID:{checked: BOOLEAN, count: COUNT}}}
    @return [result: Boolean]
  */
  [MutationTypes.UPDATE_CONTRACT_COUNT] (state, countInfos) {
    if (!countInfos || Object.keys(countInfos).length === 0) {
      return true
    }
    for (let contractid in countInfos) {
      if (contractid in state.contractSkuCounts) {
        Object.assign(state.contractSkuCounts[contractid], countInfos[contractid])
      } else {
        state.contractSkuCounts[contractid] = countInfos[contractid]
      }
    }
    state.contractSkuCounts = {...state.contractSkuCounts}
    sysUtil.setLocalStore('contractCount', state.contractSkuCounts)
    return true
  },
  [MutationTypes.INIT_CONTRACT_COUNT] (state) {
    let contractCount = sysUtil.getLocalStore('contractCount')
    if (!contractCount) {
      console.log('cannot get contract count')
      return
    }

    state.contractSkuCounts = JSON.parse(contractCount)
  },
  [MutationTypes.SET_ORDER_FILTERS] (state, filters) {
    state.orderFilters = filters
  },

  [MutationTypes.CLEAR_CUSTOM_COMPANY_CONFIG] (state, filters) {
    state.customCompanyConfig = null
  },

  [MutationTypes.INIT_STORE] (state) {
    this.commit(MutationTypes.INIT_GET_WXCODE_STATUS)
    this.commit(MutationTypes.INIT_USEROAUTH)
    this.commit(MutationTypes.INIT_CONTRACT_COUNT)
    this.commit(MutationTypes.INIT_OPERATION_STATUS)
    this.commit(MutationTypes.INIT_ORDER_PAYMETHOD)
    this.commit(MutationTypes.INIT_OPENID)
    this.commit(MutationTypes.INIT_SUPPLIER_SKU_MAP)
    this.commit(MutationTypes.INIT_ORDERINFO)
    this.commit(MutationTypes.INIT_BUYER_SHOPID)
    this.commit(MutationTypes.INIT_SELLER_CUSTOMID)
  },

  [MutationTypes.CLEAR_STORE] (state) {
    this.commit(MutationTypes.CLEAR_USEROAUTH)
    this.commit(MutationTypes.CLEAR_SHOPPINGCART)
    this.commit(MutationTypes.CLEAR_OPERATION_STATUS)
    this.commit(MutationTypes.CLEAR_ORDER_PAYMETHOD)
    this.commit(MutationTypes.CLEAR_USERINFO)
    this.commit(MutationTypes.CLEAR_ORDERINFO)
    this.commit(MutationTypes.CLEAR_BUYER_SHOPID)
    this.commit(MutationTypes.CLEAR_SUPPLIER_SKU_MAP)
    this.commit(MutationTypes.CLEAR_CUSTOM_COMPANY_CONFIG)
    this.commit(MutationTypes.CLEAR_SELLER_CUSTOMID)
  }
}



// WEBPACK FOOTER //
// ./src/apps/buyerapp/store/mutations.js